import { FileError } from 'use-file-picker';
import React from 'react';
import { AttachmentInputBody } from './AttachmentInputBody';
import { AttachmentInputErrorMessages } from '../../SingleAttachmentInputFormField/AttachmentInputErrorMessages';
import { MimeTypeAsString } from '../../../utils/fileMimeTypes';

interface PropTypes {
  allowedFormats: MimeTypeAsString[];
  disabled: boolean;
  isLoading: boolean;
  fileErrors: FileError[];
  maxFiles: number;
  maxFileSizeMb: number;
  maxFilesSizeMb: number;
  openFileSelector: () => void;
}

export function FileInput(props: PropTypes) {
  return (
    <>
      <AttachmentInputErrorMessages
        allowedFormats={props.allowedFormats}
        errors={props.fileErrors}
        maxFileSizeMb={props.maxFileSizeMb}
        maxFiles={props.maxFiles}
        maxFilesSumSizeMb={props.maxFilesSizeMb}
      />
      <AttachmentInputBody
        allowedFormats={props.allowedFormats}
        disabled={props.disabled}
        isLoading={props.isLoading}
        openFileSelector={props.openFileSelector}
      />
    </>
  );
}
